import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addCommentTdsSignOffReportApi,
  approveTdsSignOffReportApi,
  getAllTanNumberListApi,
  getSignOffTdsReportDetailsApi,
  getSignOffTdsReportListApi,
  getTdsPayableListApi,
  getTdsReceivableListApi,
  postSaveTdsEntryApi,
  signOffTdsReportApi,
} from "@/apis/tdsTcsManagementApi";

import {
  AddCommentTdsSignOffReportPayloadType,
  GetAllTanNumberListPayloadType,
  GetSignOffTdsReportPayloadType,
  GetTdsTcsListPayloadType,
  PostSaveTdsEntryPayloadType,
} from "@/commonTypes/TdsTcsManagementType";

export const getTdsReceivableListAction = createAsyncThunk(
  "get/tdsReceivableList",
  async (data: GetTdsTcsListPayloadType) => {
    const response = await getTdsReceivableListApi(data);
    return response.data;
  }
);

export const getTdsPayableListAction = createAsyncThunk(
  "get/tdsPayableList",
  async (data: GetTdsTcsListPayloadType) => {
    const response = await getTdsPayableListApi(data);
    return response.data;
  }
);

export const postSaveTdsEntryAction = createAsyncThunk(
  "post/tdsPayableList",
  async (data: PostSaveTdsEntryPayloadType) => {
    const response = await postSaveTdsEntryApi(data);
    return response.data;
  }
);

export const getSignOffTdsReportListAction = createAsyncThunk(
  "get/signOffTdsReportList",
  async (data: GetSignOffTdsReportPayloadType) => {
    const response = await getSignOffTdsReportListApi(data);
    return response.data;
  }
);

export const getSignOffTdsReportDetailsAction = createAsyncThunk(
  "get/signOffTdsReportDetails",
  async (data: GetSignOffTdsReportPayloadType) => {
    const response = await getSignOffTdsReportDetailsApi(data);
    return response.data;
  }
);

export const approveTdsSignOffReportAction = createAsyncThunk(
  "post/approveTdsSignOffReport",
  async (data: GetSignOffTdsReportPayloadType) => {
    const response = await approveTdsSignOffReportApi(data);
    return response.data;
  }
);

export const addCommentTdsSignOffReportAction = createAsyncThunk(
  "post/addCommentTdsSignOffReport",
  async (data: AddCommentTdsSignOffReportPayloadType) => {
    const response = await addCommentTdsSignOffReportApi(data);
    return response.data;
  }
);

export const signOffTdsReportAction = createAsyncThunk(
  "post/signOffTdsReport",
  async (data: GetSignOffTdsReportPayloadType) => {
    const response = await signOffTdsReportApi(data);
    return response.data;
  }
);

export const getAllTanNumberListAction = createAsyncThunk(
  "clientSettings/getAllTanNumber",
  async (data: GetAllTanNumberListPayloadType) => {
    const response = await getAllTanNumberListApi(data);
    return response.data;
  }
);
